import { useEffect, useState } from 'react';

interface IWindowSize {
	windowWidth?: number;
	windowHeight?: number;
}

export const useWindowSize = () => {
	const [windowSize, setWindowSize] = useState<IWindowSize>({
		windowWidth: undefined,
		windowHeight: undefined,
	});

	useEffect(() => {
		function handleResize() {
			setWindowSize({
				windowWidth: window.innerWidth,
				windowHeight: window.innerHeight,
			});
		}

		if (typeof window !== 'undefined') {
			window.addEventListener('resize', handleResize);
			handleResize();
			return () => window.removeEventListener('resize', handleResize);
		}

		return undefined;
	}, []);
	return windowSize;
};
